import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassoMobilModalComponent } from './passolig-mobil-modal.component';
import { MainPipe } from 'src/app/common/mainpipe.module';
import { AktifButtonModule } from '../../atoms/button/aktif-button.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [PassoMobilModalComponent],
  imports: [CommonModule, MainPipe, AktifButtonModule, FormsModule],
  exports: [PassoMobilModalComponent],
})
export class PassoMobilModalModule {
  getComponent() {
    return PassoMobilModalComponent;
  }
}
